import { lockScroll, unlockScroll } from '@theme/utilities';
import { getScrollTop, scrollTo } from '@theme/scroll-container';

class IsarkSizeGuide extends HTMLElement {
  #dialog;
  #opener;
  #events;
  #ownsHistoryEntry = false;
  #scrollTop = 0;

  connectedCallback() {
    this.#dialog = this.querySelector('dialog');
    this.#opener = this.querySelector('[data-isark-size-open]');
    if (!this.#dialog || !this.#opener) return;
    this.#events = new AbortController();
    const options = { signal: this.#events.signal };
    this.#opener.addEventListener('click', this.#show, options);
    this.querySelector('[data-isark-size-close]')?.addEventListener('click', this.#close, options);
    this.#dialog.addEventListener('cancel', this.#cancel, options);
    this.#dialog.addEventListener('close', this.#onClosed, options);
    this.#dialog.addEventListener('click', this.#outside, options);
    window.addEventListener('popstate', this.#onBack, options);
  }

  disconnectedCallback() {
    this.#events?.abort();
    if (this.#dialog?.open) unlockScroll(this.#dialog);
  }

  #show = () => {
    if (this.#dialog.open) return;
    this.#scrollTop = getScrollTop();
    lockScroll(this.#dialog);
    this.#dialog.showModal();
    history.pushState({ ...history.state, isarkSizeGuide: this.id }, '');
    this.#ownsHistoryEntry = true;
  };

  #close = () => this.#dialog.close();

  #cancel = (event) => {
    event.preventDefault();
    this.#close();
  };

  #outside = (event) => {
    if (event.target !== this.#dialog) return;
    const rect = this.#dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.#close();
  };

  #onClosed = () => {
    unlockScroll(this.#dialog);
    scrollTo({ top: this.#scrollTop, behavior: 'instant' });
    this.#opener.focus({ preventScroll: true });
    if (!this.#ownsHistoryEntry) return;
    this.#ownsHistoryEntry = false;
    if (history.state?.isarkSizeGuide === this.id) history.back();
  };

  #onBack = () => {
    if (!this.#ownsHistoryEntry || history.state?.isarkSizeGuide === this.id) return;
    this.#ownsHistoryEntry = false;
    if (this.#dialog.open) this.#close();
  };
}

if (!customElements.get('isark-size-guide')) customElements.define('isark-size-guide', IsarkSizeGuide);
